const Thankyou = () => {
    return <h1>The purchase is done successfully!</h1>
}

export default Thankyou;